import * as React from 'react';
import * as RadixTooltip from '@radix-ui/react-tooltip';
import { cn } from '@restworld/utils-common';

const placementToSide: Record<string, RadixTooltip.TooltipContentProps['side']> = {
  top: 'top',
  bottom: 'bottom',
  left: 'left',
  right: 'right',
  auto: undefined,
};

export interface TooltipProps {
  children: React.ReactNode;
  content: React.ReactNode;
  placement?: 'top' | 'bottom' | 'left' | 'right' | 'auto';
  className?: string;
  style?: 'dark' | 'light' | 'auto';
  forceOpen?: boolean;
  trigger?: 'hover';
  animation?: string;
}

export function Tooltip({
  children,
  content,
  placement = 'top',
  className,
  style: tooltipStyle = 'dark',
  forceOpen,
}: TooltipProps) {
  const side = placementToSide[placement];

  return (
    <RadixTooltip.Provider delayDuration={200}>
      <RadixTooltip.Root open={forceOpen || undefined}>
        <RadixTooltip.Trigger asChild>
          <span className="w-full">{children}</span>
        </RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <RadixTooltip.Content
            side={side}
            sideOffset={5}
            className={cn(
              'z-[1000] max-w-[320px] text-center rounded-lg px-3 py-2 text-sm shadow-lg',
              'animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
              tooltipStyle === 'light'
                ? 'bg-white text-neutral-700 border border-neutral-90'
                : 'bg-neutral-700 text-white',
              className
            )}
          >
            {content}
            <RadixTooltip.Arrow className={cn(tooltipStyle === 'light' ? 'fill-white' : 'fill-neutral-700')} />
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
}

export default Tooltip;
